import {
  listAuthAccounts,
  selectAuthAccount,
} from "../../../api/auth/accountSelection";

function normalizeAccount(account) {
  const user = account?.user && typeof account.user === "object" ? account.user : {};

  return {
    id: account?.id || "",
    name: account?.trade_name || account?.name || account?.legal_name || "Conta sem nome",
    legalName: account?.legal_name || "",
    documentType: account?.document_type || "",
    documentNumber: account?.document_number || "",
    logoUrl: account?.account_logo_url || account?.logo_url || account?.logoUrl || "",
    planName: account?.plan_name || "Plano não informado",
    permissions:
      account?.permissions && typeof account.permissions === "object"
        ? account.permissions
        : null,
    permissionsLoaded: Boolean(account?.permissions),
    status: account?.account_status || account?.accountStatus || account?.status || "",
    accountStatus: account?.account_status || account?.accountStatus || account?.status || "",
    roleName: account?.role?.name || "",
    roleSlug: account?.role?.slug || "",
    isAccountOwner: Boolean(account?.is_account_owner),
    user: {
      avatarConfig: user.avatar_config || account?.user_avatar_config || null,
      displayName: user.display_name || account?.user_display_name || "",
      nickname: user.nickname || account?.user_nickname || "",
      pictureUrl: user.picture_url || account?.user_picture_url || "",
    },
  };
}

export async function getSelectableAccounts() {
  const response = await listAuthAccounts();
  const data = response?.data || {};

  return {
    accounts: Array.isArray(data.accounts)
      ? data.accounts.map(normalizeAccount)
      : [],
    accountsCount: Number(data.accounts_count || 0),
    accountSelectionRequired: Boolean(data.account_selection_required),
  };
}

export async function chooseAccount(accountId) {
  const response = await selectAuthAccount(accountId);
  const data = response?.data || {};

  return {
    ...data,
    selected_account: data.selected_account
      ? normalizeAccount(data.selected_account)
      : null,
  };
}
